import { JusIaIcon } from '@farol-ds/react'
import classNames from 'classnames'

import styles from './compare-plans-table.module.scss'
import {
  Benefit,
  CreateFeatureProps,
  GetFeaturesProps,
  PlanFeature,
  PlanFeatureLabel,
  TableData,
} from './types'

const createFeature = ({ hasFeature, className }: CreateFeatureProps): PlanFeature => ({
  contains: hasFeature,
  label: hasFeature ? PlanFeatureLabel.CONTAINS : PlanFeatureLabel.NOT_CONTAINS,
  className,
})

const getPlanFeatures = ({
  addBasic,
  addAdvanced,
  addJusAI,
  jusAIClass,
}: GetFeaturesProps): Benefit['planFeatures'] => [
  createFeature({ hasFeature: addBasic }),
  createFeature({ hasFeature: addAdvanced }),
  createFeature({ hasFeature: addJusAI, className: jusAIClass || styles.planJusAI }),
]

export const tableData: TableData = {
  plans: [
    { label: 'Básico' },
    { label: 'Avançado' },
    { label: 'Avançado + Jus IA', className: classNames(styles.planJusAI, styles.radiusTop) },
  ],
  benefits: [
    {
      description: 'Pesquisa por jurisprudência, modelos e peças',
      planFeatures: getPlanFeatures({ addBasic: true, addAdvanced: true, addJusAI: true }),
      popoverDescription: 'Pesquisa, cópia e download de Jurisprudência, Modelos e Peças',
    },
    {
      description: 'Busca por processos judiciais',
      planFeatures: getPlanFeatures({ addBasic: true, addAdvanced: true, addJusAI: true }),
      popoverDescription: 'Consulte processos por nome, CPF ou número CNJ',
    },
    {
      description: 'Acesso ao acervo de Doutrina',
      planFeatures: getPlanFeatures({ addBasic: false, addAdvanced: true, addJusAI: true }),
      popoverDescription:
        'Acesso a Doutrina com mais de 1900 livros dos autores mais consagrados do Direito',
    },
    {
      icon: <JusIaIcon className={styles.iconJusAI} />,
      description: 'Acesso liberado ao Jus IA',
      planFeatures: getPlanFeatures({
        addBasic: false,
        addAdvanced: false,
        addJusAI: true,
        jusAIClass: classNames(styles.planJusAI, styles.radiusBottom),
      }),
      popoverDescription:
        'Busca confiável com IA na maior base jurídica do país, criação automatizada de peças e análise segura de referências',
    },
  ],
}
